<template>
    <section class="sticky-top d-none d-md-block bg-white z-9 pt-5">
        <div class="mt-5 px-3 px-xl-0">
            <div
                class="d-flex gap-lg-3 gap-xl-5 justify-content-center border-bottom border-light-gray mx-auto max-w-xl"
                >
                <a href="#program-lojalnosti" class="px-4 mb-2 text-dark">
                    Program lojalnosti
                </a>
                <a href="#skeniraj-i-plati" class="px-4 mb-2 text-dark">
                    Skeniraj i plati
                </a>
                <a href="#moji-kuponi" class="px-4 mb-2 text-dark"> Moji kuponi </a>
                <a href="#moj-auto" class="px-4 mb-2 text-dark"> Moj auto </a>
                <a href="#faq" class="px-4 mb-2 text-dark"> FAQ </a>
            </div>
        </div>
    </section>
</template>

<style scoped>
a {
    text-decoration: none;
    font-size: 0.875rem;
}

a:hover,
a:active,
a:focus {
    color: var(--color-main) !important;
}

.border-light-gray {
    border-color: #eaeaea !important;
}

.z-9 {
  z-index: 9;
}
</style>
